import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: 'a[href^="#abbr-"], *[data-abbreviation]',
        closeBtn: '.abbreviation__close-btn',
        overlay: '.abbreviation__overlay',
        trigger: '.abbreviation__trigger',
        body: 'body',
        wrapper: '.abbreviation',
        overlaySquare: '.abbreviation__overlay-square',
    },
    classNames: {
        overlayVisible: 'abbreviation__overlay--visible',
    },
};

class Abbreviation {
    static count = 1;
    static data = null;
    static ids = [];
    static idCounterMap = {};

    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._count = 1;
        this._id = '';
        this._title = '';
        this._content = '';
        this._$parent = null;
        this._$overlay = null;
        this._$trigger = null;
        this._isInserted = false;
        this._isVisible = false;
    }

    init() {
        // extract id from element
        let id = null;

        if(this._$rootElement.attr('href')) {
            id = this._$rootElement.attr('href').substring(6);
        } else if(this._$rootElement.data('abbreviation')) {
            id = this._$rootElement.data('abbreviation').substring(6);
        }

        if(id === null) {
            // console.log('no id');
            return;
        } 

        this._id = id;

        if(!Abbreviation.idCounterMap[id]) {
            Abbreviation.idCounterMap[id] = Abbreviation.count;
            this._count = Abbreviation.count;
            Abbreviation.count++;
        } else {
            this._count = Abbreviation.idCounterMap[id];
        }

        // find matching element
        let abbr = null;
        
        Abbreviation.data.forEach(element => {
            if(element.id == this._id) {
                abbr = element;
            }
        });

        if(abbr === null) {
            // console.log('no abbr');
            return;
        } 


        
        this._title = abbr.title;
        this._content = abbr.content;

        const html = this._generateHTML();
        const parent = this._$rootElement[0].parentNode;
        const $parent = $(parent);
        this._$parent = $parent;
        parent.replaceChild($(html)[0], this._$rootElement[0]);
        const $trigger = $parent.find('.abbreviation__trigger--' + this._id);

        this._$trigger = $trigger;
        
        $trigger.on('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            const $overlays = $('.abbreviation__overlay');
            $overlays.css('opacity', 0);
            $overlays.css('pointer-events', 'none');

            if(this._isInserted) {
                this._reposition();
                this._$overlay.css('opacity', 1);
                this._$overlay.css('pointer-events', 'all');
                this._isBodyNoScroll(false);
                
            } else {
                const overlayHtml = this._generateOverlayHtml();
                $('main').append(overlayHtml);
                this._isInserted = true;

                this._$overlay = $(`#abbreviation-overlay-${this._id}`);
                this._$overlay.css('pointer-events', 'all');

                this._reposition();
                
                setTimeout(() => {
                    this._$overlay.css('opacity', 1);
                    this._isBodyNoScroll(false);
                }, 100)
                
                this._$overlay.find('.abbreviation__close-btn').on('mousedown', (e) => {
                    e.stopPropagation();
                    e.preventDefault();
        
                    this._$overlay.css('opacity', 0);
                    this._$overlay.css('pointer-events', 'none');
                    this._isBodyNoScroll(true);
                });

                $('body').on('mousedown', () => {
                    this._$overlay.css('opacity', 0);
                    this._$overlay.css('pointer-events', 'none');
                    this._isBodyNoScroll(true);
                });

                this._$overlay.find('p').on('mousedown', (e) => {
                    e.stopPropagation();
                });

                this._$overlay.find('.abbreviation__backdrop').on('click', (e) => {
                    this._$overlay.css('opacity', 0);
                    this._$overlay.css('pointer-events', 'none');
                    this._isBodyNoScroll(true);
                });

                this._$overlay.find('a').on('mousedown', (e) => {
                    e.stopPropagation();
                });

                this._$overlay.on('mousedown', (e) => {
                    e.stopPropagation();
                });

                $(window).on('resize', () => {
                    this._reposition();
                });
            } 
        });

        $parent.find('.abbreviation').on('mousedown', (e) => {
            e.stopPropagation();
            e.preventDefault();
        });

        

        $('body').on('mousedown', () => {
            $('body').find('.abbreviation__overlay').removeClass('abbreviation__overlay--visible');
        })
    }

    _getOffset( el ) {
        var _x = 0;
        var _y = 0;
        while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
            _x += el.offsetLeft - el.scrollLeft;
            _y += el.offsetTop - el.scrollTop;

            el = el.offsetParent;
        }
        return { top: _y, left: _x };
    }

    _reposition() {
        // maybe we need to reposition the overlay, because there is not enough space on right side
        const $root = this._$trigger.closest('.abbreviation');
        const $overlay = $('body').find('.abbreviation__overlay');

        if(!this._$overlay) return;

        const offsetLeft = $root[0].offsetLeft;
        const overlayWidth = this._$overlay[0].clientWidth;

        // mobile
        if(Breakpoints.isBreakpoint('xs')) {
            this._$overlay.css('right', '0');
            this._$overlay.css('left', '0');
            this._$overlay.css('bottom', '0');
            this._$overlay.css('top', 'auto');
            this._$overlay.css('transform', 'none');
            this._$overlay.focus();
            return;
        } 

        // other devices 
        if($(window).width() - offsetLeft < overlayWidth) {
            if(this._$trigger.closest('.slick-track')) {
                // we are inside a slider
                const $track = this._$trigger.closest('.slick-track');
                var matrix = new WebKitCSSMatrix($track.css('transform'));
                this._$overlay.css('left', this._getOffset(this._$trigger[0]).left + 55 + matrix.m41+ 'px');
            }
            else {
                this._$overlay.css('left', this._getOffset(this._$trigger[0]).left - 35 + 'px');
            }

            this._$overlay.find('.abbreviation__overlay-square').css('left', 'auto');
            this._$overlay.find('.abbreviation__overlay-square').css('right', '30px');
            this._$overlay.css('transform', 'translate(-100%,-100%)');
            this._$overlay.css('right', 'auto');
            this._$overlay.css('bottom', 'auto');
            this._$overlay.css('top', this._getOffset(this._$trigger[0]).top - 25 + 'px');
            this._$overlay.focus();

        } else {

            if(this._$trigger.closest('.slick-track')) {
                // we are inside a slider
                const $track = this._$trigger.closest('.slick-track');
                var matrix = new WebKitCSSMatrix($track.css('transform'));
                this._$overlay.css('left', this._getOffset(this._$trigger[0]).left - 35 + matrix.m41+ 'px');
            }
            else {
                this._$overlay.css('left', this._getOffset(this._$trigger[0]).left - 35 + 'px');
            }

            this._$overlay.find('.abbreviation__overlay-square').css('right', 'auto');
            this._$overlay.find('.abbreviation__overlay-square').css('left', '30px');
            this._$overlay.css('transform', 'translateY(-100%)');
            this._$overlay.css('bottom', 'auto');
            this._$overlay.css('top', this._getOffset(this._$trigger[0]).top - 25 + 'px');
            this._$overlay.css('right', 'auto');
            this._$overlay.focus();
        }
    }

    static async _fetch() {
        // get ids of all needed abbreviations
        const ids = [];

        $(config.selectors.root).each((i, el) => {
            const $el = $(el);
            let id = '';

            if($el.attr('href')) {
                id = $el.attr('href').substring(6);
            } else if($el.data('abbreviation')) {
                id = $el.data('abbreviation').substring(6);
            }
            
            if(id === '') return;

            ids.push(id);
        });

        
        const finishedSplittedUrl = this._extractIsoAndLanguageFromUrl();
       
        if(ids.length === 0) return;
        
        try {
            let data;

            if(window.location.hostname === 'localhost') {
                data = await $.get('/assets/abbreviations.json?ids=' + ids.join(','));          
            } else {
                data = await $.get( `/${finishedSplittedUrl.isoCode}/${finishedSplittedUrl.languageSelected}` + `/abbreviations.json?ids=` + ids.join(','));            
            }
            
            if(!data) {
                return;
            }

            Abbreviation.data = data;

            // modules should initialize after we have the data
            moduleRegistry.autoApplyModule('Abbreviation', config.selectors.root);
        } catch (error) {
            // console.log('Couldnt initialize abbreviations', error);
        }
    }


    static _extractIsoAndLanguageFromUrl() {
        const currentUrl = window.location.pathname;
        const splittedUrl = currentUrl.split('/')
        const splittedIsoCode = splittedUrl[1]
        const splittedLanguage = splittedUrl[2]
        return {
          isoCode: splittedIsoCode,
          languageSelected: splittedLanguage
        }
    }

    _generateHTML() {
        return `
            <span class="abbreviation">
                <button class="abbreviation__trigger abbreviation__trigger--${this._id}" type="button">${this._count}</button>
            </span>
        `;
    }

    _generateOverlayHtml(left, top) {
        return `
            <div class="abbreviation__overlay" id="abbreviation-overlay-${this._id}">
                <div class="abbreviation__backdrop"></div>
                <div class="abbreviation__overlay-inner">
                    <button class="abbreviation__close-btn" type="button">x</button>
                    <span class="abbreviation__title">${this._title} [${this._count}]</span>
                    <div class="abbreviation__content">${this._content}</div>
                </div>
                <div class="abbreviation__overlay-square"></div>
            </div>
        `;
    }
    _isBodyNoScroll(toRemove=Boolean) {
        if(window.innerWidth < 768) {
            if(toRemove === false) {
                $('body').addClass('body--no-scroll')
            }else {
                $('body').removeClass('body--no-scroll')
            }  
        }
        $(window).on('resize', () => {
            $('body').removeClass('body--no-scroll')
            if(window.innerWidth < 768) {
                if(toRemove === false) {
                    $('body').addClass('body--no-scroll')
                }else {
                    $('body').removeClass('body--no-scroll')
                }
            }
        });
    }
}

moduleRegistry.registerModule('Abbreviation', Abbreviation);

Abbreviation._fetch();
